import { Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";
import { private_routes, public_routes, company_private_routes, IRoute } from "routes";
import CircleLoader from "components/atoms/CircleLoader";
import { useAppSelector } from "redux/hooks";
import AuthService from "services/auth.service";

export default function AppRoutes() {
	const user = useAppSelector((state) => state.auth.user);
	const [routesAccess, setRoutesAccess] = useState<IRoute[]>([]);
	const [loading, setLoading] = useState<Boolean>(true);

	useEffect(() => {
		if (user) {
			let private_routesCheck = [];
			private_routesCheck.push(...private_routes);
			if (!user.company_id)
				private_routesCheck.push(...company_private_routes);

			console.log("private_routesCheck", private_routesCheck)
			setRoutesAccess(private_routesCheck);
			setLoading(false);
		} else {
			AuthService.logout();
			setLoading(false);
		}

	}, [user])


	return (
		<div style={{ minHeight: "92vh", position: "relative", background: "#fafbfc" }}>
			{loading ? (
				<CircleLoader />
			) : (
				<Suspense fallback={<CircleLoader />}>
					<Routes>
						{public_routes.map(({ path, element }, i) => (
							<Route key={i} path={path} element={element} />
						))}

						{routesAccess.map(({ path, element }, i) => (
							<Route
								key={i}
								path={path}
								element={<PrivateRoute>{element}</PrivateRoute>}
							/>
						))}

						<Route path="*" element={<Navigate to="/" />} />
						{/* <Route path="*" element={<NotFound />} /> */}
					</Routes>
				</Suspense>
			)}
		</div>
	);
}
